import React from 'react'
 import './ServicesBenefitsSection.css'
export default function ServicesBenefitsSection({ title, description, benefits }) {
  return (
   <>
   <section className="benefits-section">
      <div className="benefits-container">
        <h2 className="benefits-title">{title}</h2>
        <p className="benefits-description">{description}</p>
        <div className="benefits-list">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-item">
              <div className="benefit-icon">{benefit.icon}</div>
              <div className="benefit-content">
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-text">{benefit.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
   
   
   
   
   </>
  )
}
